import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const ratingsOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.RATINGS,
    steps: [
        {
            id: "rat-welcome",
            title: "Central de Avaliações",
            description:
                "Acompanhe a satisfação dos usuários com as avaliações de motoristas e passageiros.",
            position: "center",
        },
        {
            id: "rat-table",
            title: "Tabela de Avaliações",
            description:
                "Veja todas as avaliações com nota, comentário, data e participantes. Use para monitorar a qualidade do serviço.",
            targetId: "ratings-table",
            position: "bottom",
        },
        {
            id: "rat-filters",
            title: "Filtros por Nota",
            description:
                "Filtre avaliações por nota mínima/máxima, período ou tipo (motorista/passageiro) para análise detalhada.",
            targetId: "ratings-filters",
            position: "bottom",
        },
    ],
};
